import {useEffect, useContext} from 'react';
import {logEvent} from '@firebase/analytics';
import {useLocation} from 'react-router-dom';

import {analytics} from '-/firebase';

import {SettingsContext} from '-/contexts/Settings';

import useActivityTracker from '-/hooks/useActivityTracker';

export default function(title) {
    const {siteName = 'Ember Tracking'} = useContext(SettingsContext);
    const location = useLocation();

    useActivityTracker();

    // `siteName` belongs in the deps, not just `title`. Without it the effect
    // never re-ran on a settings change, so the tab title kept whatever name was
    // current when the page mounted: renaming the department in Settings updated
    // the navbar and dashboard greeting live but left the tab stale until the
    // next navigation, and on a cold start the title stuck at the "Ember
    // Tracking" fallback because it was written before settings arrived.
    // This hook is the only writer of document.title, so re-running it is safe.
    useEffect(() => {
        document.title = title ? `${title} | ${siteName}` : siteName;
    }, [title, siteName]);

    useEffect(() => {
        if (!analytics) return;
        try {
            logEvent(analytics, 'screen_view', {
                firebase_screen: location.pathname,
                firebase_screen_class: 'firebase-routes-analytics'
            });
        } catch(e) {
            console.warn('Failed to log screen view:', e);
        }
    }, [location]);

    return null;
}